import React, { FC, useState } from "react";
import { AckTable, AckTableRowProps } from "../common/AckTable";
import { ModelSpec } from "../common/AckModelForm";
import { AckErrorMessage, AckLoader, useEffectLoader, useLoader } from "../common/AckUI";
import { useFetch } from "../common/AckFetch";

const frontendBuildTimestamp = String(process.env.BUILD_TIMESTAMP);
const frontendLibName = String(process.env.ACKBOX_LIB_NAME);
const frontendLibVersion = String(process.env.ACKBOX_LIB_VERSION);

const VersionSummary = () => {
  const ackLoader = useLoader();
  const ackFetch = useFetch("/actuator");
  const [backendData, setBackendData] = useState({} as any);

  useEffectLoader(ackLoader, async () => {
    const data = await ackFetch.get("info");
    setBackendData(data);
    console.log(data);
  });

  const Summary: FC = () => {
    const spec: ModelSpec[] = [
      { key: "createdAt", label: "Created At", name: "createdAt", type: "datetime-local" },
      { key: "libraryType", label: "Library Type", name: "libraryType", type: "text" },
      { key: "libraryName", label: "Library Name", name: "libraryName", type: "text" },
      { key: "libraryVersion", label: "Library Version", name: "libraryVersion", type: "text" },
    ];
    const rows: AckTableRowProps[] = [
      {
        spec: spec, payload: {
          createdAt: frontendBuildTimestamp,
          libraryType: "Frontend",
          libraryName: frontendLibName,
          libraryVersion: frontendLibVersion,
        },
      },
      {
        spec: spec, payload: {
          createdAt: backendData.git.commit.time,
          libraryType: "Backend",
          libraryName: `${backendData.build.group}.${backendData.build.name}`,
          libraryVersion: `${backendData.git.branch}@${backendData.git.commit.id}`,
        },
      },
    ];
    return (<AckTable rows={rows}/>);
  };

  return (
    <>
      <AckErrorMessage errors={ackLoader.errors}/>
      <AckLoader isLoading={ackLoader.isLoading}/>
      {!ackLoader.isLoading && <Summary/>}
    </>
  );
};

export const AckStatusz: FC = () => {
  return (
    <div className="section">
      <h1 className="title is-spaced">System Information</h1>
      <VersionSummary/>
    </div>
  );
};
